<template>
  <div class="container" style="background-color: #FFFAF4;">
    <HeaderComponent :menu-id="3"></HeaderComponent>
    <div>
      <!-- 标题 -->
      <div class="title-ty" style="padding-bottom: 50px;">
        <div class="title-ty-y">SHUISHI GRADING</div>
        <div class="title-ty-z"><span>机制币送评</span>免责条款</div>
      </div>
      <div style="background-color: #FFFAF4;">
        <div class="tiaokuan-box">
          <div class="tixing"><span>特别提醒:</span> 您一经选择水石评级的服务，即视为接受本承诺全部条款，若您不接受本
承诺全部或部分条款，请及时向我们作出说明。</div>
          <p class="p-ty">1.水石评级结论仅针对送检实物当下真伪、品相负责，不承诺藏品未来市场价格、升值、变现价值，不承担行情波动带来的经济
损失;</p>
          <p class="p-ty">2.受当下科技鉴定技术限制，极个别高仿币无法100%甄别，除官方约定赔付场景外，非约定漏判不予额外赔偿;</p>
          <p class="p-ty">3.不可抗力(火灾、水灾、物流意外、政策变动)导致服务延期、藏品损毁，按物流/保险规则理赔，水石评级不承担超额赔偿;</p>
          <p class="p-ty">4.送评人隐瞒修补、改刻、改色等人为改动，经评级后发现，水石评级有权补标瑕疵代码、降分，不承担任何赔付;</p>
          <p class="p-ty">5.拆盒裸币送检、私自拆开评级盒，原评级结论失效，不再适用假币入盒赔付政策。</p>
          <p class="p-ty">6.原水石评级币(无论盒子完好/砸盒)，凭藏品编号可终身查询档案、享受复检售后;无编号、币体改动后不再享受售后质
保;</p>
          <p class="p-ty">7.邮寄送评:寄件保价费用由送评方自行承担，保价丢失按快递公司保价协议理赔。</p>
          <p class="p-ty">8.收到缴费通知后3个工作日内付清服务费;逾期未缴费藏品水石代为保管3个月;超过3个月经3次催告仍未付费，视为送评人
放弃藏品所有权，水石有权处置藏品抵扣欠费，余款留存公司。</p>
        </div>
      </div>
        
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.p-ty{
  margin-top: 40px;
}
</style>